import React, { useState, useRef, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { Grid, Typography, Tabs, Tab, Container } from "@material-ui/core";

import { getAbrirAnchor } from "../../../../../services/deepLinkAnchor";
import { configContainerTabKeyPara } from "../../../../../services/deepLinkRegistry";

import EventRegistryConfig from "../../../AuthorizedUsers/EventsConfig/EventRegistryConfig";
import EventRegistryConfigSubEvents from "../../../AuthorizedUsers/EventsConfig/EventRegistryConfigSubEvents";
import EventAditionalInputsContainer from "../../../AuthorizedUsers/EventsConfig/EventAdicionalInputs/EventAditionalInputsContainer";
import EventProductsContainer from "../../../AuthorizedUsers/EventsConfig/EventProducts/EventProductsContainer";
import EventInventoryContainer from "../../../AuthorizedUsers/EventsConfig/EventInventory/EventInventoryContainer";
import EventMonedaContainer from "../../../AuthorizedUsers/EventsConfig/EventMoneda/EventMonedaContainer";
import EventRaceNumber from "../../../AuthorizedUsers/EventsConfig/EventRaceNumber/EventRaceNumber";
import EventRaceNumberToPrint from "../../../AuthorizedUsers/EventsConfig/EventRaceNumber/EventRaceNumberToPrint";
import FolioManagementContainer from "./FolioManagement/FolioManagementContainer";
import EventDiscountCodesContainer from "../../../AuthorizedUsers/EventsConfig/EventDiscountCodes/EventDiscountCodesContainer";
import EventConvocatoryContainer from "../../../AuthorizedUsers/EventsConfig/EventConvocatory/EventConvocatoryContainer";
import EventMailContainer from "../../../AuthorizedUsers/EventsConfig/MailConfig/EventMailContainer";
import EtiquetasConfigContainer from "../PrintLabels/EtiquetasConfigContainer";
import BulkEditInscritos from "./BulkEdit/BulkEditInscritos";
import DeslindeConfigContainer from "./Deslinde/DeslindeConfigContainer";
import ConfigSectionInfo from "./ConfigSectionInfo";
import configSectionsInfoText from "./configSectionsInfoText";
import NoveltyTabDot from "../../../Changelog/NoveltyTabDot";
import NoveltyInfoButton from "../../../Changelog/NoveltyInfoButton";

function TabContainer({ titulo, infoTexto, novedadAnchors, onNoveltySeen, children }) {
  return (
    <Typography component="div" style={{ padding: "20px 8px" }}>
      <Grid container justify="flex-end" alignItems="center">
        {novedadAnchors && (
          <Grid item>
            <NoveltyInfoButton anchors={novedadAnchors} onSeen={onNoveltySeen} />
          </Grid>
        )}
        <Grid item>
          <ConfigSectionInfo titulo={titulo}>{infoTexto}</ConfigSectionInfo>
        </Grid>
      </Grid>
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  titulo: PropTypes.string.isRequired,
  infoTexto: PropTypes.string.isRequired,
  novedadAnchors: PropTypes.arrayOf(PropTypes.string),
  onNoveltySeen: PropTypes.func,
  children: PropTypes.node.isRequired,
};

export default function RegistryConfigurationContainer({ abrirAnchor }) {
  const eventDetail = useSelector((state) => state.events.eventDetail);
  const atleteAccount = useSelector((state) => state.atlete.atleteAccount);
  const [value, setValue] = useState(0);
  // Fuerza un re-render inmediato cuando se marca una novedad como vista
  // (NoveltyInfoButton, dentro del contenido del tab activo), para que el
  // punto decorativo de NoveltyTabDot en la barra de tabs desaparezca al
  // instante en vez de esperar a que algo más cause un re-render.
  const [, forceNoveltyTick] = useState(0);
  const onNoveltySeen = () => forceNoveltyTick((t) => t + 1);

  // Deep-link desde el changelog/tooltips (?abrir=...): el índice del tab
  // objetivo depende de si "Edición masiva" está incluido (perfil Master),
  // así que se resuelve después de construir arrayTabs más abajo, no antes.
  const tabKeysRef = useRef([]);
  const anchorResueltoRef = useRef(false);
  // Sin arreglo de dependencias a propósito: corre tras cada render hasta
  // que tabKeysRef.current tenga el arrayTabs ya construido (puede tardar
  // más de un render si el primero cae en el "Error Recarga la web" de
  // abajo). anchorResueltoRef evita que dispare setValue más de una vez.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (anchorResueltoRef.current) return;
    const anchor = abrirAnchor || getAbrirAnchor();
    const targetKey = configContainerTabKeyPara(anchor);
    if (!targetKey) return;
    const index = tabKeysRef.current.indexOf(targetKey);
    if (index !== -1) {
      anchorResueltoRef.current = true;
      setValue(index);
    }
  });

  let { EventoIndex } = useParams();
  console.log("eventDetail", eventDetail);
  if ("evento_" + eventDetail.iDEvento !== EventoIndex) {
    return (
      <Grid container direction="row" alignItems="flex-start">
        <Grid item xs={12}>
          <Typography gutterBottom variant={"h2"} component="h2">
            Error Recarga la web
          </Typography>
        </Grid>
      </Grid>
    );
  }

  function handleChange(event, newValue) {
    setValue(newValue);
  }

  const arrayTabs = [
    <Tab key="tab-inscripciones" label="Inscripciones" />,
    <Tab key="tab-modalidades" label="Modalidades y categorías" />,
    <Tab key="tab-campos" label="Campos adicionales" />,
    <Tab key="tab-productos" label="Productos" />,
    <Tab
      key="tab-inventarios"
      label={<NoveltyTabDot anchors={["tab-inventarios"]}>Inventarios</NoveltyTabDot>}
    />,
    <Tab
      key="tab-dorsal"
      label={<NoveltyTabDot anchors={["tab-dorsal"]}>Dorsales o folios</NoveltyTabDot>}
    />,
    <Tab
      key="tab-descuentos"
      label={<NoveltyTabDot anchors={["tab-descuentos"]}>Códigos de descuento</NoveltyTabDot>}
    />,
    <Tab key="tab-convocatoria" label="Convocatoria" />,
    <Tab
      key="tab-correos"
      label={
        <NoveltyTabDot anchors={["tab-correos-campana"]}>Configuración de correos</NoveltyTabDot>
      }
    />,
    <Tab
      key="tab-deslinde"
      label={<NoveltyTabDot anchors={["tab-deslinde"]}>Deslinde de responsabilidades</NoveltyTabDot>}
    />,
        <Tab key="tab-monedas" label="Monedas" />,

    <Tab
      key="tab-etiquetas"
      label={<NoveltyTabDot anchors={["tab-etiquetas"]}>Etiquetas</NoveltyTabDot>}
    />,
    ...(atleteAccount && atleteAccount.perfil === 1
      ? [
          <Tab
            key="tab-edicion-masiva"
            label={<NoveltyTabDot anchors={["tab-edicion-masiva"]}>Edición masiva</NoveltyTabDot>}
          />,
        ]
      : []),
  ];

  tabKeysRef.current = arrayTabs.map((tab) => tab.key);

  const contentTabs = [
    <TabContainer
      key="content-inscripciones"
      titulo="Configuración de inscripciones"
      infoTexto={configSectionsInfoText.inscripciones}
    >
      <EventRegistryConfig />
    </TabContainer>,
    <TabContainer
      key="content-modalidades"
      titulo="Modalidades y categorías"
      infoTexto={configSectionsInfoText.modalidadesYCategorias}
    >
      <EventRegistryConfigSubEvents />
    </TabContainer>,
    <TabContainer
      key="content-campos"
      titulo="Campos adicionales"
      infoTexto={configSectionsInfoText.camposAdicionales}
    >
      <EventAditionalInputsContainer />
    </TabContainer>,
    <TabContainer
      key="content-productos"
      titulo="Productos"
      infoTexto={configSectionsInfoText.productos}
    >
      <EventProductsContainer />
    </TabContainer>,
    <TabContainer
      key="content-inventarios"
      titulo="Inventarios"
      infoTexto={configSectionsInfoText.inventarios}
      novedadAnchors={["tab-inventarios"]}
      onNoveltySeen={onNoveltySeen}
    >
      <EventInventoryContainer />
    </TabContainer>,
    <TabContainer
      key="content-dorsal"
      titulo="Dorsales o folios"
      infoTexto={configSectionsInfoText.dorsalDigital}
      novedadAnchors={["tab-dorsal"]}
      onNoveltySeen={onNoveltySeen}
    >
      <FolioManagementContainer />
      <EventRaceNumber />
      {atleteAccount.perfil ===1 &&
      <EventRaceNumberToPrint />
      }

    </TabContainer>,
    <TabContainer
      key="content-descuentos"
      titulo="Códigos de descuento"
      infoTexto={configSectionsInfoText.codigosDeDescuento}
      novedadAnchors={["tab-descuentos"]}
      onNoveltySeen={onNoveltySeen}
    >
      <EventDiscountCodesContainer />
    </TabContainer>,
    <TabContainer
      key="content-convocatoria"
      titulo="Convocatoria"
      infoTexto={configSectionsInfoText.convocatoria}
    >
      <EventConvocatoryContainer />
    </TabContainer>,
    <TabContainer
      key="content-correos"
      titulo="Configuración de correos"
      infoTexto={configSectionsInfoText.configuracionDeCorreos}
      novedadAnchors={["tab-correos-campana"]}
      onNoveltySeen={onNoveltySeen}
    >
      <EventMailContainer />
    </TabContainer>,
    <TabContainer
      key="content-deslinde"
      titulo="Deslinde de responsabilidades"
      infoTexto={configSectionsInfoText.deslindeResponsabilidades}
      novedadAnchors={["tab-deslinde"]}
      onNoveltySeen={onNoveltySeen}
    >
      <DeslindeConfigContainer />
    </TabContainer>,
        <TabContainer
      key="content-monedas"
      titulo="Monedas"
      infoTexto={configSectionsInfoText.monedas}
    >
      <EventMonedaContainer />
    </TabContainer>,

    <TabContainer
      key="content-etiquetas"
      titulo="Etiquetas"
      infoTexto={configSectionsInfoText.etiquetas}
      novedadAnchors={["tab-etiquetas"]}
      onNoveltySeen={onNoveltySeen}
    >
      <EtiquetasConfigContainer />
    </TabContainer>,
    ...(atleteAccount && atleteAccount.perfil === 1
      ? [
          <TabContainer
            key="content-edicion-masiva"
            titulo="Edición masiva de inscritos"
            infoTexto={configSectionsInfoText.edicionMasiva}
            novedadAnchors={["tab-edicion-masiva"]}
            onNoveltySeen={onNoveltySeen}
          >
            <BulkEditInscritos />
          </TabContainer>,
        ]
      : []),
  ];

  return (
    <Container maxWidth="lg">
      <Tabs
        value={value}
        scrollButtons="auto"
        variant="scrollable"
        onChange={handleChange}
      >
        {arrayTabs}
      </Tabs>
      {contentTabs[value]}
    </Container>
  );
}
